export default {
	title: "Lignées spirituelles",
	name: "Nom",
	primaryColor: "Couleur principale",
	description: "Description",
	create: "Nouvelle lignée spirituelle",
	edit: "Modifier la lignée spirituelle",
	confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer la lignée spirituelle \"{name}\" ?",
	stats: {
		total: "Total des lignées",
	},
	delete: {
		hasLinksWarning: "Cette lignée a {guides} guide(s) et {ritualTypes} type(s) de rituel associé(s). Ils seront déplacés vers la lignée sélectionnée avant la suppression.",
		reassignLabel: "Déplacer les guides et types de rituel vers",
		reassignAndDelete: "Déplacer et supprimer",
		noTargetLines: "Aucune autre lignée disponible pour la réaffectation",
	},
	messages: {
		createSuccess: "Lignée spirituelle créée avec succès",
		updateSuccess: "Lignée spirituelle mise à jour avec succès",
		deleteSuccess: "Lignée spirituelle supprimée avec succès",
		reassignDeleteSuccess: "Éléments réaffectés et lignée spirituelle supprimée avec succès",
		createError: "Erreur lors de la création de la lignée spirituelle",
		updateError: "Erreur lors de la mise à jour de la lignée spirituelle",
		deleteError: "Erreur lors de la suppression de la lignée spirituelle",
		loadError: "Erreur lors du chargement des lignées spirituelles",
	},
	searchPlaceholder: "Rechercher des lignées spirituelles...",
	noData: "Aucune lignée spirituelle trouvée",
	noDataSubtext: "Commencez par créer votre première lignée spirituelle",
	searchNoResults: "Aucune lignée trouvée pour '{search}'",
	form: {
		description: "Description",
		icon: "Icône",
		name: "Nom de la lignée",
		primaryColor: "Couleur principale",
	},
	validation: {
		nameRequired: "Le nom est obligatoire",
		nameMaxLength: "Le nom doit avoir au maximum 100 caractères",
		descriptionMaxLength: "La description doit avoir au maximum 500 caractères",
	},
};
